import React, { Component } from 'react';
import { TimelineMax } from 'gsap';

import { getBtnClass } from '@triage-help/helpers';

const generateSummaryContent = (title, content) => {
  return `<h2>${title}</h2><p>${content}</p>`;
};

class Checker extends Component {
  constructor(props) {
    super(props);

    this.tl = null;
    this.state = {
      content: null,
      progress: 0,
      errorDisplayed: false,
      status_summary: [],
      prevContent: null,
      checkCompleted: false,
      allowContinue: true,
    };
  }

  componentDidMount() {
    let previous_summary = {};
    let error_content = {};
    this.tl = new TimelineMax({
      onComplete: (() => {
        this.setState({
          checkCompleted: true,
          status_summary: [...this.state.status_summary, previous_summary],
          content: generateSummaryContent(
            this.props.step.checks_complete_title,
            this.props.step.checks_complete_summary,
          ),
        });
      }).bind(this),
    });
    this.props.step.stages.forEach((el, index) => {
      if (this.props.status[this.props.step.stages[index].id]) {
        this.tl.to(document, el.duration, {
          onStart: (() => {
            const selectedChannel = [];
            let channelString = '';
            this.setState({
              content: el.content,
              errorDisplayed: false,
              progress:
                ((Number(this.tl.time().toFixed(1)) + el.duration) /
                  this.tl.duration()) *
                100,
            });

            if (Object.keys(error_content).length !== 0) {
              this.tl.pause();
              this.setState({
                ...error_content,
                prevContent: el.content,
              });
              error_content = {};
            }

            if (
              this.props.status[this.props.step.stages[index].id] &&
              this.props.status[this.props.step.stages[index].id].status
            ) {
              if (
                this.props.status[this.props.step.stages[index].id].channel_list
              ) {
                this.props.status[
                  this.props.step.stages[index].id
                ].channel_list.forEach((e, i) => {
                  if (e.status === true) {
                    selectedChannel.push(e.channel);
                  }
                });
                channelString = selectedChannel.join(', ');
                if (selectedChannel.length > 1) {
                  channelString += ' are';
                } else {
                  channelString += ' is';
                }
              }

              let issue_content = this.props.step.stages[index].issue_content;

              error_content = {
                content: issue_content
                  .replace('@channels', channelString)
                  .replace('@transmitter', this.props.status.transmitter),
                errorDisplayed: true,
                allowContinue: this.props.status[
                  this.props.step.stages[index].id
                ].continue,
              };
            }

            if (
              this.props.step.stages[index] &&
              this.props.status[this.props.step.stages[index].id]
            ) {
              if (Object.keys(previous_summary).length !== 0) {
                this.setState({
                  status_summary: [
                    ...this.state.status_summary,
                    previous_summary,
                  ],
                });
              }

              if (this.props.status[this.props.step.stages[index].id].status) {
                let summary_text = this.props.step.stages[index].summary.true;

                previous_summary = {
                  error: true,
                  text: summary_text.replace(
                    '@channels',
                    selectedChannel.join(', '),
                  ),
                };
              } else {
                previous_summary = {
                  error: false,
                  text: this.props.step.stages[index].summary.false,
                };
              }
            }
          }).bind(this),
        });
      }
    });
  }

  continueChecks() {
    this.tl.resume();
    this.setState({
      errorDisplayed: false,
      content: this.state.prevContent,
    });
  }

  retune() {}

  render() {
    const { step, goToStep, location } = this.props;

    return (
      <div className="fv-triage-card fv-triage-card--centered ">
        <div className="row">
          <div className="fv-triage-card__progress">
            <div
              className="fv-triage-card__progress__indicator"
              style={{ width: `${this.state.progress}%` }}
            />
          </div>
          <div className="col-md-12">
            <div
              dangerouslySetInnerHTML={{
                __html: this.state.content,
              }}
            />
            {this.state.errorDisplayed &&
              this.state.allowContinue &&
              !this.state.checkCompleted && (
                <button
                  className={getBtnClass()}
                  onClick={this.continueChecks.bind(this)}
                >
                  Continue checks
                </button>
              )}
            {!this.state.errorDisplayed && (
              <ul className="fv-triage-card__status-infos">
                {this.state.status_summary.map((el, i) => {
                  if (el.error) {
                    return (
                      <li key={i}>
                        <span className="fv-triage-card__status-infos__icon fv-triage-card__status-infos__icon--error">
                          <i className="icon-thumbs-down-lg" />
                        </span>
                        {el.text}
                      </li>
                    );
                  } else {
                    return (
                      <li key={i}>
                        <span className="fv-triage-card__status-infos__icon">
                          <i className="icon-thumbs-up-lg" />
                        </span>
                        {el.text}
                      </li>
                    );
                  }
                })}
              </ul>
            )}
          </div>
          {this.state.checkCompleted && (
            <div className="col-md-12 fv-triage-card__links">
              {step.link
                .filter(l => l.type != 'prev')
                .map((link, i) => {
                  return (
                    <button
                      className={getBtnClass(link.type)}
                      key={i}
                      onClick={() => goToStep(link.target)}
                    >
                      {link.text}
                    </button>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Checker;
